import { Component, OnInit, ViewChild,AfterViewInit } from '@angular/core';
import * as Chartist from 'chartist';
import { ActivityHistoryData } from '../../histories/history/history.component';
import { BackOffServiceService } from '../../services/back-off-service.service';
import { environment } from 'src/environments/environment';
import { LogsData } from '../../model/LogsData';
import * as Parse from 'parse';
import { Chart } from 'chart.js';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContent } from '../../alert-component';
import { FormGroup, FormControl, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { QuizData } from '../../questionaire/QuizData';


declare var $: any;
@Component({
  selector: 'app-activity-trend',
  templateUrl: './activity-trend.component.html',
  styleUrls: ['./activity-trend.component.css']
})
export class ActivityTrendComponent implements OnInit {
  coachFeedbackForm : FormGroup;
  
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );
  buttonColor = ['primary', 'primary', 'primary', 'primary', 'primary', 'default', 'default'];
  buttonMessage = ['unlogged', 'unlogged', 'unlogged', 'unlogged', 'unlogged', '', ''];
  weekColor = true;
  monthColor = false;
  weekColor2 = true;
  monthColor2 = false;
  topMessage = 'past week of data';
  botMessage = 'past week of data';

  activityStack = [0, 0, 0, 0, 0, 0, 0];
  activityStack2 = [0, 0, 0, 0, 0, 0, 0, 0];
  Activitylabels = Last7Days().reverse();
  Activitylabels2 = Last7Weeks().reverse();

  calStack = [0, 0, 0, 0, 0, 0, 0];
  calStack2 = [0, 0, 0, 0, 0, 0, 0, 0];

  limitLine = [0, 0, 0, 0, 0, 0, 0, 0];
  limitLine2 = [0, 0, 0, 0, 0, 0, 0, 0];


  data: LogsData[];
  actMin = 0;
  minRem = 0;
  minExercised = 0;
  calGoal = 1000;
  calBurned = 0;
  calRem = 0;
  canvas: any;
  ctx1: any;
  ctx2: any;
  myChart: Chart;
  myChart2: Chart;
  @ViewChild('mychart') mychart;
  @ViewChild('mychart2') mychart2;

  constructor(
    private _bkoffService: BackOffServiceService, private breakpointObserver: BreakpointObserver,
    private router: Router,
    private cookie: CookieService,
    private formBuilder : FormBuilder,
    private modalService: NgbModal,
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit() {
    this.coachFeedbackForm = this.formBuilder.group({
      weekly_log: ['', Validators.required],
      positives_negatives: ['', Validators.required],
      specific_suggestion: ['', Validators.required],
    })
  }

  get fmBuilder() { return this.coachFeedbackForm.controls; }
  getFormControl(name:any) {
    return this.coachFeedbackForm.get(name);
  }
  reset(){
    this.coachFeedbackForm.reset({PersonalData: new QuizData()});
  }
  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.coachFeedbackForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.coachFeedbackForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }

  submitFeedbackForm(){
    const result: QuizData = Object.assign({}, this.coachFeedbackForm.value); 
    if (this.coachFeedbackForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      return;
    }

    const signUpData = this.coachFeedbackForm;
     console.log(String(signUpData.get(['weekly_log']).value));
     console.log(String(signUpData.get(['positives_negatives']).value));
     console.log(String(signUpData.get(['specific_suggestion']).value));
     
      var userInfo = new QuizData()
      userInfo.weekly_log = String(signUpData.get(['weekly_log']).value)
      userInfo.positives_negatives = String(signUpData.get(['positives_negatives']).value)
      userInfo.specific_suggestion = String(signUpData.get(['specific_suggestion']).value)
      this._bkoffService.setCoachFeedbackDataActivity(userInfo);
      const modalRef = this.modalService.open(NgbdModalContent);
      this.closeFeedbackForm();
      signUpData.setValue({['positives_negatives']: null, ['specific_suggestion']: null, ['weekly_log']: null});
      modalRef.componentInstance.name = "Patient's activity feedback saved";
      modalRef.componentInstance.title = 'Success';
  };

  ngAfterViewInit() {
    this.canvas = this.mychart.nativeElement;
    this.ctx1 = this.canvas.getContext('2d');
    this.canvas = this.mychart2.nativeElement;
    this.ctx2 = this.canvas.getContext('2d');
    const patientID = this.cookie.get("patientID");
    var checkCoach = this.cookie.get('coach');

    if (checkCoach === 'true'){
      this.cookie.set("viewPatientTrends", "true");
      this._bkoffService.getActivityCaloriesGoalCoach().then((res) => {
        this.calGoal = res;
        for (let i = 0; i < this.limitLine2.length; i++) {
          this.limitLine2[i] = res;
        }
      });
      this._bkoffService.getActivityGoalCoach().then((res) => {
        console.log('res is ' + res);
        this.actMin = res;
        for (let i = 0; i < this.limitLine.length; i++) {
          this.limitLine[i] = res;
        }
  
        console.log('label 1=' + this.Activitylabels[0]);
        const ACTIVITY_DATA: ActivityHistoryData[] = [];
        const viewedDates = [];
        const today = new Date().getTime();
        let indexDay = today;
        let indexDay2 = today;
        let index = this.activityStack.length - 1;
        let index2 = this.activityStack2.length - 1;
        this._bkoffService.getActivityHistoryCoach().then((res) => {
          this.data = res;
          this.data.forEach(element => {
            console.log(element.activityDate);
            const d = this.getDay(element.activityDate);
            const m = this.getMonth(element.activityDate);
            const y = this.getYear(element.activityDate);
            const day = new Date(m + ' ' + d + ', ' + y + ' 00:00:00').getTime();
            // daily
            if (!(day < today - 604800000)) {
              const diff = Math.floor((indexDay - day) / 86400000);
              indexDay = day;
              if (index >= 0) {
                index -= diff;
                this.activityStack[index] += parseInt(element.time);
                console.log(element.activityCalories);
                if (element.activityCalories !== undefined) {
                  this.calStack[index] += element.activityCalories.valueOf();
                }
              }
            } else {
              console.log('longer than a week');
            }
            // weekly
            index2 = this.activityStack2.length - 1;
            if (!(day < today - 5184000000)) {
              const diff = Math.floor((today - day) / 604800000);
              console.log('diff: ' + diff);
              indexDay2 = day;
              if (index2 >= 0) {
                index2 -= diff;
                this.activityStack2[index2] += parseInt(element.time);
                console.log(element.activityCalories);
                if (element.activityCalories !== undefined) {
                  this.calStack2[index2] += element.activityCalories.valueOf();
                }
              }
            }
          });
          console.log('weight stak is val ' + this.activityStack);
          const axisMin = 0;
          this.minExercised = this.activityStack.reduce((a, b) => a + b, 0);
          this.minRem = Math.max(0, this.actMin - this.minExercised);
          this.calBurned = this.calStack.reduce((a, b) => a + b, 0);
          this.calRem = Math.max(0, this.calGoal - this.calBurned);
  
  
          this.myChart = new Chart(this.ctx1, {
            type: 'bar',
            data: {
              labels: this.Activitylabels,
              datasets: [
                {
                  label: 'minutes exercised',
                  type: 'bar',
                  backgroundColor: 'rgba(52, 152, 219,0.4)',
                  backgroundColorHover: '#000000',
                  data: this.activityStack
                },
                {
                  label: 'goal',
                  type: 'line',
                  borderColor: 'rgb(255, 134, 78)',
                  backgroundColor: 'rgba(255, 134, 78, 0.5)',
                  data: [],
                  fill: false,
                  borderWidth: 4,
                },
              ]
            },
            options: {
              title: {
                display: false,
                text: ''
              },
              scales: {
                xAxes: [{
                  stacked: true,
                  barPercentage: 0.6
                }],
                yAxes: [{
                  stacked: true,
                }]
              },
              legend: { display: false }
            }
          });
  
          this.myChart2 = new Chart(this.ctx2, {
            type: 'bar',
            data: {
              labels: this.Activitylabels,
              datasets: [
                {
                  label: 'calories',
                  type: 'bar',
                  backgroundColor: 'rgba(52, 152, 219,0.4)',
                  backgroundColorHover: '#3e95cd',
                  data: this.calStack
                },
                {
                  label: 'goal',
                  type: 'line',
                  borderColor: 'rgb(255, 134, 78)',
                  backgroundColor: 'rgba(255, 134, 78, 0.5)',
                  data: [],
                  fill: false,
                  borderWidth: 4,
                },
              ]
            },
            options: {
              title: {
                display: false,
                text: ''
              },
              scales: {
                xAxes: [{
                  stacked: true,
                  barPercentage: 0.6
                }],
                yAxes: [{
                  stacked: true,
                }]
              },
              legend: { display: false }
            }
          });
        });
      });
    }else{
      this._bkoffService.getActivityCaloriesGoal().then((res) => {
        this.calGoal = res;
        for (let i = 0; i < this.limitLine2.length; i++) {
          this.limitLine2[i] = res;
        }
      });

      this._bkoffService.getActivityGoal().then((res) => {
        console.log('res is ' + res);
        this.actMin = res;
        for (let i = 0; i < this.limitLine.length; i++) {
          this.limitLine[i] = res;
        }
  
        console.log('label 1=' + this.Activitylabels[0]);
        const ACTIVITY_DATA: ActivityHistoryData[] = [];
        const viewedDates = [];
        const today = new Date().getTime();
        let indexDay = today;
        let indexDay2 = today;
        let index = this.activityStack.length - 1;
        let index2 = this.activityStack2.length - 1;
        this._bkoffService.getActivityHistory().then((res) => {
          this.data = res;
          this.data.forEach(element => {
            console.log(element.activityDate);
            const d = this.getDay(element.activityDate);
            const m = this.getMonth(element.activityDate);
            const y = this.getYear(element.activityDate);
            const day = new Date(m + ' ' + d + ', ' + y + ' 00:00:00').getTime();
            // daily
            if (!(day < today - 604800000)) {
              const diff = Math.floor((indexDay - day) / 86400000);
              indexDay = day;
              if (index >= 0) {
                index -= diff;
                this.activityStack[index] += parseInt(element.time);
                console.log(element.activityCalories);
                if (element.activityCalories !== undefined) {
                  this.calStack[index] += element.activityCalories.valueOf();
                }
              }
            } else {
              console.log('longer than a week');
            }
            // weekly
            index2 = this.activityStack2.length - 1;
            if (!(day < today - 5184000000)) {
              const diff = Math.floor((today - day) / 604800000);
              console.log('diff: ' + diff);
              indexDay2 = day;
              if (index2 >= 0) {
                index2 -= diff;
                this.activityStack2[index2] += parseInt(element.time);
                console.log(element.activityCalories);
                if (element.activityCalories !== undefined) {
                  this.calStack2[index2] += element.activityCalories.valueOf();
                }
              }
            }
          });
          console.log('weight stak is val ' + this.activityStack);
          const axisMin = 0;
          this.minExercised = this.activityStack.reduce((a, b) => a + b, 0);
          this.minRem = Math.max(0, this.actMin - this.minExercised);
          this.calBurned = this.calStack.reduce((a, b) => a + b, 0);
          this.calRem = Math.max(0, this.calGoal - this.calBurned);
  
  
          this.myChart = new Chart(this.ctx1, {
            type: 'bar',
            data: {
              labels: this.Activitylabels,
              datasets: [
                {
                  label: 'minutes exercised',
                  type: 'bar',
                  backgroundColor: 'rgba(52, 152, 219,0.4)',
                  backgroundColorHover: '#000000',
                  data: this.activityStack
                },
                {
                  label: 'goal',
                  type: 'line',
                  borderColor: 'rgb(255, 134, 78)',
                  backgroundColor: 'rgba(255, 134, 78, 0.5)',
                  data: [],
                  fill: false,
                  borderWidth: 4,
                },
              ]
            },
            options: {
              title: {
                display: false,
                text: ''
              },
              scales: {
                xAxes: [{
                  stacked: true,
                  barPercentage: 0.6
                }],
                yAxes: [{
                  stacked: true,
                }]
              },
              legend: { display: false }
            }
          });
  
          this.myChart2 = new Chart(this.ctx2, {
            type: 'bar',
            data: {
              labels: this.Activitylabels,
              datasets: [
                {
                  label: 'calories',
                  type: 'bar',
                  backgroundColor: 'rgba(52, 152, 219,0.4)',
                  backgroundColorHover: '#3e95cd',
                  data: this.calStack
                },
                {
                  label: 'goal',
                  type: 'line',
                  borderColor: 'rgb(255, 134, 78)',
                  backgroundColor: 'rgba(255, 134, 78, 0.5)',
                  data: [],
                  fill: false,
                  borderWidth: 4,
                },
              ]
            },
            options: {
              title: {
                display: false,
                text: ''
              },
              scales: {
                xAxes: [{
                  stacked: true,
                  barPercentage: 0.6
                }],
                yAxes: [{
                  stacked: true,
                }]
              },
              legend: { display: false }
            }
          });
        });
      });
    }
    

    
  }

  getDay(date: string): string {
    let res = date.split(' ');
    let day = res[1];
    res = day.split(',');
    day = res[0];
    return day;
  }

  getMonth(date: string): string {
    const res = date.split(' ');
    return res[0];
  }

  getYear(date: string): string {
    const res = date.split(' ');
    return res[3];
  }


  getToday(): number {
    const d = new Date();
    const day = Number(d.getDate());
    return day;
  }

  toggleWeek() {
    if (!this.weekColor) {
      this.weekColor = !this.weekColor;
      this.monthColor = !this.monthColor;
      console.log('week toggled');
      this.myChart.data.labels = this.Activitylabels;
      this.myChart.data.datasets[0].data = this.activityStack;
      this.myChart.data.datasets[1].data = [];
      this.myChart.options.legend.display = false;
      this.myChart.update();
      this.topMessage = 'past week of data';
    }
  }

  toggleMonth() {
    if (!this.monthColor) {
      this.weekColor = !this.weekColor;
      this.monthColor = !this.monthColor;
      console.log('month toggled');
      this.myChart.data.labels = this.Activitylabels2;
      this.myChart.data.datasets[0].data = this.activityStack2;
      this.myChart.data.datasets[1].data = this.limitLine;
      this.myChart.options.legend.display = true;
      this.myChart.update();
      this.topMessage = 'past 2 months of data';
    }
  }

  toggleWeek2() {
    if (!this.weekColor2) {
      this.weekColor2 = !this.weekColor2;
      this.monthColor2 = !this.monthColor2;
      this.myChart2.data.labels = this.Activitylabels;
      this.myChart2.data.datasets[0].data = this.calStack;
      this.myChart2.data.datasets[1].data = [];
      this.myChart2.options.legend.display = false;
      this.myChart2.update();
      this.botMessage = 'past week of data';
    }
  }

  toggleMonth2() {
    if (!this.monthColor2) {
      this.weekColor2 = !this.weekColor2;
      this.monthColor2 = !this.monthColor2;
      this.myChart2.data.labels = this.Activitylabels2;
      this.myChart2.data.datasets[0].data = this.calStack2;
      this.myChart2.data.datasets[1].data = this.limitLine2;
      this.myChart2.options.legend.display = true;
      this.myChart2.update();
      this.botMessage = 'past 2 months of data';
    }
  }

  toLogs() {
    this.router.navigateByUrl('/logs');
  }

  checkCoach(): Boolean {
    console.log("checking coach");
    if (this.cookie.get('coach') === 'true') {
      return true;
    } else {
      return false;
    }
  }

  openFeedbackForm() {
    document.getElementById("feedbackForm").style.display = "block";
  }
  
  closeFeedbackForm() {
    document.getElementById("feedbackForm").style.display = "none";
  }

}


function formatDate(date) {

  let dd = date.getDate();
  let mm = date.getMonth() + 1;
  const yyyy = date.getFullYear();
  if (dd < 10) { dd = '0' + dd; }
  if (mm < 10) { mm = '0' + mm; }
  date = mm.toString() + '/' + dd.toString();
  return date;
}

function Last7Days() {
  const result = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    result.push(formatDate(d));
  }

  return (result);
}

function Last7Weeks() {
  const result = [];
  for (let i = 0; i < 8; i++) {
    const d = new Date();
    d.setDate(d.getDate() - i * 7);
    result.push(formatDate(d));
  }

  return (result);
}

function minWeight(weightArray) {
  let min = 100000;
  for (let i = 0; i < weightArray.length; i++) {
    if (weightArray[i] < min && weightArray[i] !== 0) {
      min = weightArray[i];
    }
  }
  return min;
}
